import React from 'react';
import classNames from 'classnames';
import Fade from 'components/UI_kit_3/animations/Fade/Fade';
import Loader from './Loader/Loader';
import styles from './PageLoader.module.scss';

type PageLoaderProps = React.HTMLProps<HTMLDivElement> & {
  visible?: boolean;
  className?: string;
};

// eslint-disable-next-line react/prop-types
const PageLoader: React.FC<PageLoaderProps> = ({
  className,
  visible = true,
}) => (
  <Fade
    isVisible={visible}
    duration={150}
    mountOnEnter
    unmountOnExit
  >
    <div className={classNames(styles.pageLoader, className, 'page-loader')}>
      <Loader
        className={styles.loader}
      />
    </div>
  </Fade>
);

export default PageLoader;
